import { FixedIncomePrivateProvider } from "./providers/fixed-income-private.http.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiProvider } from "./providers/api.http.service";
import { AwsProvider } from "./providers/aws.http.service";
import { WebapiProvider } from "./providers/webapi.http.service";
import { GraphqlProvider } from "./providers/graphql-api.http.service";
import { SalesforceAwsProvider } from "./providers/salesforce-aws.http.service";
import { UserAcceptCampaignProvider } from "./providers/user-accept-campaign.http.service";
import { ToroCrmAwsProvider } from "./providers/toro-crm-aws.http.service";
import { GraphRentabilityProvider } from "./providers/graph-rentability-api.service";
import { SegmentProvider } from "./providers/segment.http.service";
import { SettingsService } from '../settings/settings.service';
import {BackendService as LegacyBackendService} from '../backend/backend.service'
import { StocksApiProvider } from "./providers/stocks-api.http.service";
import { ReportIncomeApiProvider } from "./providers/report-income-api.http.service";
import { UserApiProvider } from "./providers/user-api.service";
import { AdvisoryApiProvider } from "./providers/advisory-api.http.service";
import { FixedIncomeApiHttpProvider } from "./providers/fixed-income-api.http.service";

@Injectable({ providedIn: "root" })
export class BackendService {
    /**
     * Serviços de backend
     *
     * @param api - Amazon Cloudfront generalista
     * @param aws - Amazon Gateway
     * @param webapi - API legada do Hub
     * @param graphqlApi - Graphql da Toro
     * @param salesforceAws - Api gateway AWS do salesforce
     * @param userAcceptCampaing - API de Aceite para Campanhas (contratos)
     * @param fixedIncomePrivate - API de renda fixa privada
     * @param graphRentability - API da dados de rentabilidade
     * @param segment - Proxy da API do Segment
     * @param settingsService - Settings service
     * @param legacyBackendService - Settings service
     * @param stocksApi - Api generalizada para área de bolsa
     * @param reportIncomeApiProvice - Api de informe de rendimentos
     * @param advisoryApi - Api generalizada de informações do assessorado
     * @param fixedIncomeApi - API de renda fixa geral
     */
    constructor(
        public api: ApiProvider,
        public aws: AwsProvider,
        public http: HttpClient,
        public webapi: WebapiProvider,
        public graphqlApi: GraphqlProvider,
        public salesforceAws: SalesforceAwsProvider,
        public toroCrmAws: ToroCrmAwsProvider,
        public graphRentability: GraphRentabilityProvider,
        public fixedIncomePrivate: FixedIncomePrivateProvider,
        public segment: SegmentProvider,
        public settingsService: SettingsService,
        public legacyBackendService: LegacyBackendService,
        public stocksApi: StocksApiProvider,
        public userApi: UserApiProvider,
        public advisoryApi: AdvisoryApiProvider,
        protected userAcceptCampaing: UserAcceptCampaignProvider,
        protected reportIncomeApiProvider: ReportIncomeApiProvider,
        public fixedIncomeApi: FixedIncomeApiHttpProvider,
    ) {}
}
